import Header from "../../containers/header";
import Navbar from "../../containers/navbar";
import HomeIcon from "../../assets/images/homeimg.png";
import { connect } from "react-redux";
import "./homepage.css";
import { getIndentData } from "../../api";
import ErrorModal from "../../containers/error_modal";
import { useRef, useState } from "react";

const HomePage = ({ ...props }) => {
  const { widthIsSmall, loc } = props;
  const [lambdaError, setLambdaError] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const openErrRef = useRef();
  const closeErrRef = useRef();

  const downloadIndentData = async () => {
    if (isLoading) return;

    try {
      setIsLoading(true);
      const payload = {
        loc: loc,
        file: true,
      };

      const indentData = await getIndentData(payload);

      if (indentData?.status === "error") {
        throw new Error(indentData?.error_message || "Unable to download indent data");
      }

      const fileUrl = indentData?.body?.file_url;
      if (!fileUrl) throw new Error("Download file was not returned");

      const downloadLink = document.createElement("a");
      downloadLink.href = fileUrl;
      downloadLink.download = "";
      downloadLink.rel = "noopener noreferrer";
      document.body.appendChild(downloadLink);
      downloadLink.click();
      downloadLink.remove();
    } catch (error) {
      console.log(error);
      setLambdaError(error?.message || String(error));
      openErrRef.current?.click();
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="d-flex flex-column homepage">
      <Header />
      <Navbar />
      <div className="d-flex flex-column align-items-center">
        <div className="align-items-center d-flex flex-column flex-lg-row flex-md-row flex-xl-row wms-header">
          <div className="homepage-text">Welcome to</div>
          <div className="wms-text">&nbsp;RogueOne</div>
        </div>
        <img
          className="home-icon"
          src={HomeIcon}
          alt="homeimage"
          style={{ width: widthIsSmall ? "75%" : "40%" }}
        />
        <button
          className="btn btn-proceed indent-download-button d-flex align-items-center"
          onClick={downloadIndentData}
          disabled={isLoading}
        >
          {/* <img className="back-icon me-2" src={BackIcon} alt="back" /> */}
          <div>{isLoading ? "Downloading..." : "Download Indent Data"}</div>
          {isLoading && <div className="spinner ms-2"></div>}
        </button>
      </div>
      <ErrorModal
        id={"errorModal"}
        openRef={openErrRef}
        closeRef={closeErrRef}
        headerColor={"red"}
        msg={lambdaError}
      />
    </div>

  );
};
const mapStateToProps = (state) => {
  return {
    widthIsSmall: state?.auth?.widthIsSmall,
    loc: state?.auth?.user?.loc,

  };
};

const mapDispatchToProps = (dispatch) => {
  return {};
};
export default connect(mapStateToProps, mapDispatchToProps)(HomePage);
